/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiFinalRiskLevel } from './InternalApiFinalRiskLevel';
import {
    InternalApiFinalRiskLevelFromJSON,
    InternalApiFinalRiskLevelFromJSONTyped,
    InternalApiFinalRiskLevelToJSON,
    InternalApiFinalRiskLevelToJSONTyped,
} from './InternalApiFinalRiskLevel';

/**
 * 
 * @export
 * @interface InternalApiRisk
 */
export interface InternalApiRisk {
    /**
     * 
     * @type {number}
     * @memberof InternalApiRisk
     */
    id: number;
    /**
     * 
     * @type {InternalApiFinalRiskLevel}
     * @memberof InternalApiRisk
     */
    level: InternalApiFinalRiskLevel;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRisk
     */
    factor: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRisk
     */
    details: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiRisk
     */
    weight: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiRisk
     */
    createdTime: Date;
}



/**
 * Check if a given object implements the InternalApiRisk interface.
 */
export function instanceOfInternalApiRisk(value: object): value is InternalApiRisk {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('factor' in value) || value['factor'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function InternalApiRiskFromJSON(json: any): InternalApiRisk {
    return InternalApiRiskFromJSONTyped(json, false);
}

export function InternalApiRiskFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRisk {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'level': InternalApiFinalRiskLevelFromJSON(json['level']),
        'factor': json['factor'],
        'details': json['details'],
        'weight': json['weight'],
        'createdTime': (new Date(json['createdTime'])),
    };
}

export function InternalApiRiskToJSON(json: any): InternalApiRisk {
    return InternalApiRiskToJSONTyped(json, false);
}

export function InternalApiRiskToJSONTyped(value?: InternalApiRisk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'level': InternalApiFinalRiskLevelToJSON(value['level']),
        'factor': value['factor'],
        'details': value['details'],
        'weight': value['weight'],
        'createdTime': value['createdTime'].toISOString(),
    };
}

